import React from 'react';

function PageHeader({ title, subtitle, actions }) {
    return (
        <header className="sol-page-header">
            <div>
                <h1 className="sol-page-title">{title}</h1>
                {subtitle && <p className="sol-page-subtitle">{subtitle}</p>}
            </div>
            {actions && <div className="sol-page-actions">{actions}</div>}
        </header>
    );
}

export default PageHeader;
